// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P8TF","right":"styles_right__afvoj"};